import { z } from 'zod'

export const schema = z.object({
  recommendedCottages: z.array(
    z.object({
      cottageUId: z.string(),
      name: z.string(),
      url: z.string(),
      rate: z.number(),
      numComments: z.number().int(),

      media: z.object({
        url: z.string(),
      }),
      province: z.object({
        name: z.string(),
      }),
      village: z.object({
        name: z.string(),
      }),

      averagePrice: z.object({
        amount: z.number().int(),
        currency: z.string(),
      }),
      distance: z.object({
        length: z.number(),
        unit: z.string(),
      }),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  id: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
